import React from 'react'

const FaceBookPlugin = () => {
  return (
    <div className='panel panel-primary'>
      <div className='panel-heading'>
        <h2 className='panel-title'>Like us</h2>
      </div>
      <div className='panel-body text-center'>
        <div id='fb-root'></div>
        <div className='fb-page' data-href='https://www.facebook.com/HolidayExtras' data-small-header='false' data-adapt-container-width='true' data-hide-cover='false' data-show-facepile='true' data-show-posts='true'>
          <div className='fb-xfbml-parse-ignore'>
            <blockquote cite='https://www.facebook.com/HolidayExtras'>
              <a href='https://www.facebook.com/HolidayExtras'>Holiday Extras</a>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaceBookPlugin



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/faceBookPlugin.jsx